<template>
    <div class="help-sidebar" :class="{ open: isOpen }">
        <button class="close" @click="closeSidebar">×</button>
        <div class="content">
            <template v-if="help">
                <div v-html="help.content"></div>
            </template>
        </div>
    </div>
</template>

<script>
import { HelpEventBus } from '../directives/bindHelp'
import mixins from "@/js/mixins.js";

export default {
    name: 'HelpSidebar',
    data() {
        return {
            help: null,
            helpId: null,
            isOpen: false,
        }
    },
    mounted() {
        HelpEventBus.addEventListener('open-help', this.handleHelpOpen);
    },
    beforeUnmount() {
        HelpEventBus.removeEventListener('open-help', this.handleHelpOpen);
    },
    methods: {
        handleHelpOpen(event) {
            this.helpId = event.detail.id;
            this.isOpen = true;

            this.$http.get(this.apiBaseUrl + 'help/show/' + this.helpId +  '?lang=' + this.language).then(function (response) {
                this.help = response.body;
                this.$forceUpdate();
                console.log(this.help);
            }.bind(this), function (response) {
                console.log('There was an error fetching data from API. Error code ' + response.status);

                this.$router.push({ name: 'error404' }).catch(err => {
                    // Ignore the error regarding  navigating to the page they are already on.
                    if (
                        err.name !== 'NavigationDuplicated' &&
                        !err.message.includes('Avoided redundant navigation to current location')
                    ) {
                        console.error(err);
                    }
                });
            }.bind(this));
        },
        closeSidebar() {
            this.isOpen = false;
        }
    },
    mixins: [mixins],
}
</script>